"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const copyObject_1 = __importDefault(require("./copyObject"));
const keys_1 = __importDefault(require("../keys"));
/**
 * The base implementation of `assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @ignore
 * @param object The destination object.
 * @param source The source object.
 * @returns Returns `object`.
 */
function baseAssign(object, source) {
    return object && (0, copyObject_1.default)(source, (0, keys_1.default)(source), object);
}
exports.default = baseAssign;
